import { render, staticRenderFns } from "./registerMessage.vue?vue&type=template&id=7f2ecd12&"
import script from "./registerMessage.vue?vue&type=script&lang=js&"
export * from "./registerMessage.vue?vue&type=script&lang=js&"
import style0 from "./registerMessage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports